import React, {useEffect, useState} from "react";
import ProviderCard from './ProviderCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProviderSlider.css";

const ProviderList = () => {
    const [physiciansData, setPhysiciansData] = useState([])

    useEffect(() => {
        if (window.parent) {
            window.parent.postMessage({name: 'getPhysiciansData', value: 'AKJEriUbpt-providersFrame'}, '*');
        }
        window.addEventListener("message", (e) => {
            setPhysiciansData(e.data.value)
        });
    }, []);

    return <>
        <div className="provider-list">
            {
                physiciansData !== undefined && physiciansData.length > 0 ?
                    physiciansData.map((item, index) => {
                        return <ProviderCard data={item} key={item.id} index={index}/>;
                    }) : ''
            }
        </div>
    </>;
};

export default ProviderList;
